import localForage from "localforage";
import {
  combineReducers,
  configureStore,
  isRejectedWithValue,
  Middleware,
  MiddlewareAPI,
} from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import { PersistPartial } from "redux-persist/es/persistReducer";

import { generatorApi, routeApi } from "../services/baseApi";

import queueReducer from "./Queue/slice";
import stopPointReducer from "./StopPoint/slice";
import notificationReducer from "./Notification/slice";
import appInfoReducer from "./AppInfo/slice";
import Sentry from "../libs/sentry";

const persistConfig = {
  key: "root",
  storage: localForage,
  whitelist: ["queue", "notification", "appInfo"],
};

const rootReducer = combineReducers({
  [routeApi.reducerPath]: routeApi.reducer,
  [generatorApi.reducerPath]: generatorApi.reducer,
  stopPoint: stopPointReducer,
  queue: queueReducer,
  notification: notificationReducer,
  appInfo: appInfoReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const rtkQueryErrorLogger: Middleware =
  (_: MiddlewareAPI) => (next) => (action) => {
    if (isRejectedWithValue(action)) {
      const errorPayload = action.payload as any;
      const message =
        errorPayload?.data?.detail ?? errorPayload?.error ?? errorPayload.data;

      Sentry.captureException(message, errorPayload);
    }

    return next(action);
  };

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(
      rtkQueryErrorLogger,
      routeApi.middleware as any,
      generatorApi.middleware
    ),
});

export const persistor = persistStore(store);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState> & PersistPartial;
